import React, { useState } from 'react';
import Slick from './Slick';
import Control from './control';

const Example = () => {
    const list = [
        {
            id: 'reading',
            component: <Slick />
        },
        {
            id: 'control',
            component: <Control />
        }
    ];
    const [data, setData] = useState(list[0]);

    const _handleClickButton = (id) => {
        setData(list.find((item) => item.id === id));
    };

    return (
        <div id="example" className="section example">
            <h2 className="section__title">Example</h2>
            <div className="row__button">
                <Button active={data.id === 'reading'} onClick={() => _handleClickButton('reading')}>
                    Representation Reading
                </Button>
                <Button active={data.id === 'control'} onClick={() => _handleClickButton('control')}>
                    Representation Control
                </Button>
            </div>
            {data.component}
        </div>
    );
};

const Button = ({ active = false, onClick = () => {}, children }) => {
    return (
        <div className={`button ${active ? 'active' : ''}`} onClick={onClick}>
            <p>{children}</p>
        </div>
    );
};

export default Example;
